<p-table
  #dt
  [columns]="cols"
  [value]="products_current_datasource"
  [style]="{ width: '100%', 'background-color': '#fff' }"
  styleClass="p-datatable-gridlines"
  responsiveLayout="scroll"
  scrollDirection="horizontal"
  [scrollable]="true"
  [scrollHeight]="scrollHeight"
  [lazy]="true"
  (onLazyLoad)="loadProducts($event)"
  [lazyLoadOnInit]="false"
  [paginator]="true"
  [rows]="rows"
  [first]="first"
  [totalRecords]="totalRecords"
  [loading]="loading_table"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [rowsPerPageOptions]="TableRowsCounts"
  [globalFilterFields]="globalfilterFields"
  class="table_quik"
  paginatorDropdownAppendTo="body"
>
  <ng-template pTemplate="body" let-rowData>
    <div
      class="table__card__item"
      style="height: 277px; border: 1px solid #e78514"
      [ngClass]="
        rowData._id === selectedRow
          ? 'table__list__item__selected'
          : 'table__list__item__unselected'
      "
      (click)="clickProduct(rowData)"
    >
      <!-- ===== PRIMARY TITLE ===== -->
      <span class="crd-stl-hd mr-2">
        {{ rowData.S_NO }}.
        {{ rowData.activeIngredient || rowData.activeIngredient }}
      </span>

      <!-- ========== UPDATED SECONDARY BUTTON (gbrn_products) ========== -->
      <div
        class="table__card__item__row"
        *ngIf="rowData?.gbrn_products?.length"
      >
        <ng-container *ngFor="let secRowData of rowData.gbrn_products">
          <a
            type="button"
            target="_blank"
            [href]="
              'https://www.chemrobotics.com/agropat-lighter/product-' +
              (secRowData?.link || '')
            "
            style="
              display: inline-flex;
              align-items: center;
              background-color: #e78514 !important;
              color: white;
              border: none;
              border-radius: 5px;
              padding: 6px 16px;
              cursor: pointer;
              text-decoration: none;
              gap: 5px;
              font-size: 12px;
              margin-bottom: 10px;
              margin-right: 10px;
            "
            *ngIf="secRowData?.activeIngredient"
          >
            To View Scientific Info On AgroPat -
            {{ secRowData.activeIngredient }}

            <img
              src="../../../../../assets/icons/white_arrow.png"
              alt="Visit icon"
              style="width: 16px; height: 16px; display: inline-block"
            />
          </a>
        </ng-container>
      </div>
      <!-- ========== END UPDATED SECONDARY BUTTON ========== -->

      <!-- ===== PRIMARY & SECONDARY FIELDS ===== -->
      <div class="mb-1" *ngFor="let temp_row of viewFields">
        <div class="row g-3">
          <!-- Bootstrap row -->

          <ng-container *ngFor="let temp_col of temp_row.fields">
            <!-- Primary Field -->
            <ng-container *ngIf="rowData[temp_col.field]">
              <div class="col-md-6">
                <div class="table__card__item__box">
                  <h5>{{ temp_col.displayColumnName }}</h5>

                  <div class="table__card__item__data long-wrap">
                    <span
                      appHighlight
                      [searchedWords]="searchedWords"
                      [text]="addDataSpace(rowData[temp_col.field])"
                      classToApply="highlight__keyword_1"
                    ></span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Secondary Field -->
            <ng-container
              *ngIf="!rowData[temp_col.field] && rowData?.gbrn_products?.length"
            >
              <div class="col-md-6 col-12">
                <div
                  class="table__card__item__box"
                >
                  <h5>{{ temp_col.displayColumnName }}</h5>

                  <div class="table__card__item__data long-wrap">
                    <ng-container
                      *ngFor="let sec of rowData.gbrn_products; let i = index"
                    >
                      <ng-container *ngIf="sec[temp_col.field]">
                        <span *ngIf="i">, </span>
                        <span
                          appHighlight
                          [searchedWords]="searchedWords"
                          [text]="addDataSpace(sec[temp_col.field])"
                          classToApply="highlight__keyword_1"
                        ></span>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</p-table>
